import { useState } from 'react';

export const eventVariants = {
  active: {
    opacity: 1,
    scale: 1,
    filter: 'grayscale(0%)',
    transition: { duration: 0.5, ease: 'easeInOut' }
  },
  inactive: {
    opacity: 0.6,
    scale: 0.95,
    filter: 'grayscale(100%)',
    transition: { duration: 0.5, ease: 'easeInOut' }
  },
  moving: {
    scale: 1.1,
    zIndex: 1000,
    transition: { duration: 0.3 }
  }
};

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const useEventAnimation = () => {
  const [isTransitioning, setIsTransitioning] = useState(false);

  const startTransition = async (callback: () => Promise<void>) => {
    try {
      setIsTransitioning(true);
      await callback();

      setTimeout(() => {
        setIsTransitioning(false);
      }, 500);
    } catch (error) {
      setIsTransitioning(false);
      throw error;
    }
  };

  const getAnimationProps = (isActive: boolean, uniqueId: string) => ({
    variants: eventVariants,
    animate: isTransitioning ? 'moving' : isActive ? 'active' : 'inactive',
    layout: true,
    layoutId: `event-${uniqueId}`
  });

  return {
    isTransitioning,
    startTransition,
    getAnimationProps,
    eventVariants,
    containerVariants
  };
};
